//Built-in libraries
import { useState } from 'react';

//Third party libraries

//Custom components
import Button from 'components/UI/Button';
import CompanyCompletedProject from './CompanyCompletedProject';
import PrincipalCompletedProject from './PrincipalCompletedProject';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function Experience() {
  const [formError, setFormError] = useState('');

  const { setCurrentStep, data } = useApplicationFormContext();

  const nextHandler = () => {
    if (
      data.experience.companyCompleted.length === 0 &&
      data.experience.principalCompleted.length === 0
    ) {
      setFormError('At least one experience is required.');
    } else {
      setCurrentStep((prev) => prev + 1);
    }
  };

  return (
    <div className='space-y-6 p-6 lg:col-span-8 rounded-md'>
      <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>
        Experience
      </h3>
      <CompanyCompletedProject />
      <PrincipalCompletedProject />
      {formError.length > 0 && (
        <p className='text-tertiaryColor-normal'>{formError}</p>
      )}
      <div className='flex gap-4 justify-end'>
        <Button
          label='Previous'
          btnStyle='neutral'
          type='button'
          onClick={() => setCurrentStep((prev) => prev - 1)}
        />
        <Button
          label='Next'
          btnStyle='primary'
          type='button'
          onClick={nextHandler}
        />
      </div>
    </div>
  );
}
